<template>
  <my-modal>
    <div class="modal-container">
      <div class="modal-header text-center">
        <h3 class="text-center">Imprimir listado de artículos</h3>
        <button type="button" class="close" @click="cerrarModal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        class="modal-body justify-content-center"
        style="max-height:100%!important;height:auto!important;overflow:visible;"
      >
        <div class="row w-100">
          <FloatLabel label="Lista" clase=" col-md-6 col-12">
            <select
              id="lista_id"
              class="form-control"
              :class="(enviado && !$v.lista_id.required) ? 'is-invalid' : ''"
              v-model="lista_id"
            >
              <option :value="null">Seleccione lista</option>
              <option value="1">Lista 1</option>
              <option value="2">Lista 2</option>
              <option value="3">Lista 3</option>
            </select>
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.lista_id.required"
              >Debe seleccionar lista</div>
            </template>
          </FloatLabel>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="row w-100">
          <div class="col-md-4">
            <button class="btn btn-danger btn-block mb-2" @click="cerrarModal">Cerrar</button>
          </div>
          <div class="col-md-4 offset-md-4">
            <button class="btn btn-info btn-block mb-2" @click="mostrarPDF">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import MyModal from "@/components/layouts/MyModal";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import axios from 'axios'
export default {
  name: "ModalListadoArticulos",
  components: {
    MyModal,
    FloatLabel
  },
  data() {
    return {
      lista_id: null,
      enviado: false
    };
  },
  validations: {
    lista_id: { required },
  },
  created(){
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal()
      next(false)
    })

    this.$once('hook:destroyed', () => {
      unregisterRouterGuard()
    })
  },
  methods: {
    mostrarPDF() {
      this.$v.$touch();
      this.enviado = true;
      if (this.$v.$invalid) {
        return false;
      }
      let url = axios.defaults.baseURL + '/imprimir/listado-articulos?lista_id='+this.lista_id;
      window.open(url);
      // this.$emit("cerrarListadoArticulo");
    },
    cerrarModal() {
      this.$emit("cerrarListadoArticulo");
    }
  }
};
</script>